<template>
  <v-row>
    <v-col cols="12">
      <p class="font-weight-bold primary--text mb-6 form__title">
        SEGURADORA
      </p>
    </v-col>
    <v-col cols="12" class="pb-6" v-if="isEdit">
      <v-switch
        class="pa-0 ma-0 justify-self-center d-inline-block new-insurance-form__switch"
        v-model="form.ativo"
        inset
        hide-details
        dense
        color="secondary"
      />
      <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
        {{ statusSwitch }}
      </p>
    </v-col>
    <v-col>
      <BaseFormInput
        id-element="nameInsurance"
        placeholder="Insira um nome para o grupo"
        v-model="form.nome"
        required
        :rules="[requiredInput]"
        label-text="Nome da Seguradora"
        validate-on-blur
      />
    </v-col>
    <v-col cols="12" class="pb-5">
      <p class="body-2 font-weight-bold primary--text mb-2">
        Adicionar logo da seguradora
      </p>
      <BaseFileInput :item="form.logo" @update="updateLogo" />
    </v-col>
    <v-col cols="12" sm="5" md="4" class="pr-sm-5">
      <DocumentInput
        id-element="cnpjInsurance"
        placeholder="Inserir"
        v-model="form.cnpj"
        required
        :rules="[requiredInput, isValidCnpjDocument]"
        label-text="CNPJ"
        validate-on-blur
        document-type="cnpj"
      />
    </v-col>
    <v-col cols="12" sm="7" md="8">
      <BaseFormInput
        id-element="companyNameInsurance"
        placeholder="Inserir"
        v-model="form.razao_social"
        required
        :rules="[requiredInput]"
        label-text="Razão Social"
        validate-on-blur
      />
    </v-col>
    <v-col v-if="isEdit" cols="12" sm="6" class="pr-sm-5">
      <v-row>
        <v-col cols="12">
          <BaseFormInput
            id-element="susepInsurance"
            placeholder="Inserir"
            v-model="form.registro_susep"
            required
            :rules="[requiredInput, validSusep]"
            label-text="Registro SUSEP"
            validate-on-blur            
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="!isEdit" cols="12" sm="6" class="pr-sm-5">
      <BaseFormInput
        id-element="susepInsurance"
        placeholder="Inserir"
        v-model="form.registro_susep"
        required
        :rules="[requiredInput,validSusep]"
        label-text="Registro SUSEP"
        validate-on-blur
      />
    </v-col>
    <v-col cols="12" sm="6">
      <BaseFormSelect
        id-element="typeInsurance"
        :items="listInsuranceType"
        placeholder="Inserir"
        v-model="form.categoria"
        required
        :rules="[requiredInput]"
        label-text="Seguradora/Resseguradora Líder"
        validate-on-blur
        item-text="nome"
        item-value="id"
        :return-object="true"
      />
    </v-col>
    <v-col v-if="isEdit" cols="12">
      <CardPolicyCertificates :seguradoraId="id" />
    </v-col>
    <v-col cols="12" class="pb-10">
      <v-divider />
    </v-col>
    <v-col cols="12">
      <p class="font-weight-bold primary--text mb-3 form__title">
        ENDEREÇO
      </p>
    </v-col>
    <v-col cols="12" sm="6" md="2" class="pr-0 pr-sm-5">
      <BaseFormInput
        id-element="cepInsurance"
        placeholder="Inserir"
        v-model="form.endereco.cep"
        required
        :rules="[requiredInput, isValidCep]"
        validate-on-blur
        v-facade="maskCEP"
        label-text="CEP"
      />
    </v-col>
    <v-col cols="12" sm="6" class="pr-0 pr-md-5">
      <BaseFormInput
        id-element="addressInsurance"
        placeholder="Inserir"
        v-model="form.endereco.logradouro"
        required
        :rules="[requiredInput]"
        label-text="Logradouro"
      />
    </v-col>
    <v-col cols="12" sm="6" md="2" class="pr-0 pr-sm-5">
      <BaseFormInput
        id-element="numberInsurance"
        placeholder="Inserir"
        v-model="form.endereco.numero"
        required
        :rules="[requiredInput, maxLengthNumber]"
        label-text="Número"
      />
    </v-col>
    <v-col cols="12" sm="6" md="2">
      <BaseFormInput
        id-element="complementInsurance"
        placeholder="Inserir"
        v-model="form.endereco.complemento"
        label-text="Complemento"
      />
    </v-col>
    <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5">
      <BaseFormSelect
        id-element="ufInsurance"
        placeholder="Selecione"
        v-model="form.endereco.uf"
        :items="brazilianStates"
        required
        :rules="[requiredInput]"
        label-text="UF"
        item-text="nome"
        item-value="sigla"
        :return-object="true"
      />
    </v-col>
    <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
      <BaseFormInput
        id-element="cityInsurance"
        placeholder="Inserir"
        v-model="form.endereco.cidade"
        required
        :rules="[requiredInput]"
        label-text="Cidade"
      />
    </v-col>
    <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5 pr-md-0">
      <BaseFormInput
        id-element="neighborhoodInsurance"
        placeholder="Inserir"
        v-model="form.endereco.bairro"
        required
        :rules="[requiredInput]"
        label-text="Bairro"
      />
    </v-col>
    <v-col cols="12" class="pb-9">
      <v-divider />
    </v-col>
  </v-row>
</template>
<script>
const mockListInsuranceType = [
  {
    id: "seguradora",
    nome: "SEGURADORA"
  },
  {
    id: "resseguradora",
    nome: "RESSEGURADORA"
  }
];
import {
  requiredInput,
  isValidCnpjDocument,
  isValidCep,
  maxLengthNumber,
  validSusep
} from "@/utils/rules.js";
import { maskCEP } from "@/utils/masks.js";
import DocumentInput from "@/components/form/DocumentInput.vue";
import { brazilianStates } from "@/utils/utils.js";
import { mapActions } from "vuex";
import CardPolicyCertificates from "@/modules/policy/components/CardPolicyCertificates.vue";

export default {
  created() {
    this.id = this.$route.params.id.toString();
  },
  components: { CardPolicyCertificates, DocumentInput },
  data: () => ({
    requiredInput,
    isValidCnpjDocument,
    maskCEP,
    brazilianStates,
    listInsuranceType: mockListInsuranceType,
    isValidCep,
    maxLengthNumber,
    id: "",
    validSusep
  }),
  computed: {
    statusSwitch() {
      const status = this.form.ativo ? "Ativo" : "Inativo";
      return `Status ${status}`;
    }
  },
  methods: {
    ...mapActions(["showAlertNotification"]),
    updateLogo(value) {
      this.form.logo = value;
    },

    previewSusepFile() {
      if (!this.form.susepFile) {
        this.showAlertNotification({
          message: "Arquivo não encontrado!",
          type: "error"
        });
      } else {
        window.open(this.form.susepFile, "_blank").focus();
      }
    }
  },
  props: {
    form: {
      type: Object
    },
    isEdit: {
      type: Boolean
    }
  }
};
</script>
